import { render, staticRenderFns } from "./AppiLogo.vue?vue&type=template&id=b9bd31fa&scoped=true&"
import script from "./AppiLogo.vue?vue&type=script&lang=js&"
export * from "./AppiLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bd31fa",
  null
  
)

export default component.exports